import { render, staticRenderFns } from "./AtomCopyInput.vue?vue&type=template&id=bb0fe362&scoped=true&"
import script from "./AtomCopyInput.vue?vue&type=script&lang=js&"
export * from "./AtomCopyInput.vue?vue&type=script&lang=js&"
import style0 from "./AtomCopyInput.vue?vue&type=style&index=0&id=bb0fe362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0fe362",
  null
  
)

export default component.exports